import React, { useState, useEffect, useRef } from "react";


const Description = (props) => {
	const {text = ""} = props

    const [isExpanded, setIsExpanded] = useState(false)
	const [showSeeMore, setShowSeeMore] = useState(false)

	const textRef = useRef(null)

	const width = props.width ? props.width: "350px"

	useEffect(() => {
		if (textRef.current) {
			const lineHeight = parseFloat(getComputedStyle(textRef.current).lineHeight)
			const height = textRef.current.scrollHeight
			const numLines = Math.round(height / lineHeight)
			console.log("height", height, lineHeight, numLines)
			if (numLines !== 4 && numLines > 3) {
				setShowSeeMore(numLines > 3)
			}
		}
	}, [text])

    return (
		<div className="remark-description-container" style={{width}}>
			<div className={`description-text ${!isExpanded && showSeeMore ? "clamp-3-lines" : ""}`} ref={textRef}>{text}</div>
			{showSeeMore && <p className="see-more" onClick={() => setIsExpanded(!isExpanded)} >{!isExpanded ? "See More" : ""}</p>}
		</div>
	)
}

export default Description;